import { render } from "./ScheduleComponent.vue?vue&type=template&id=7a04ff01&scoped=true"
import script from "./ScheduleComponent.vue?vue&type=script&lang=js"
export * from "./ScheduleComponent.vue?vue&type=script&lang=js"

import "./ScheduleComponent.vue?vue&type=style&index=0&id=7a04ff01&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a04ff01"]])

export default __exports__